import { _ as _defineProperty } from '../defineProperty-Y-S4SptN.js';
import { _ as _slicedToArray } from '../slicedToArray-ibbgR3-O.js';
import { _ as _objectWithoutProperties } from '../objectWithoutProperties-w3bsUgPa.js';
import { forwardRef, useState } from 'react';
import classNames from 'classnames';
import noop from '../noop/index.js';
import validateInputRange from '../validateInputRange/index.js';
import createUseStyles from '../create/index.js';
import { isLeftToRight } from '../helpers/index.js';
import { j as jsxRuntimeExports } from '../jsx-runtime-KJzvSKZ_.js';

var useStyles = {
  root: {
    display: 'block',
    width: '100%',
    height: function height(_ref) {
      var _height = _ref.height;
      return _height;
    },
    padding: function padding(_ref2) {
      var height = _ref2.height;
      return "0 ".concat(height / 2, "px");
    },
    position: 'relative'
  },
  content: {
    display: 'block',
    height: '100%',
    position: 'relative'
  },
  stroke: {
    display: 'block',
    height: 2,
    borderRadius: 2,
    position: 'absolute',
    top: 0,
    bottom: 0,
    margin: ['auto', 0],
    pointerEvents: 'none'
  },
  backLayer: {
    width: '100%',
    left: 0,
    background: function background(props) {
      return props.disabled ? 'var(--x-text-color-disabled)' : 'var(--backgrounds-tint-5)';
    },
    opacity: function opacity(props) {
      return props.disabled ? 'var(--statuses-disabled)' : 'var(--texts-tint-1)';
    }
  },
  load: _defineProperty(_defineProperty({
    background: function background(props) {
      return props.disabled ? 'var(--x-text-color-disabled)' : 'var(--texts-base)';
    }
  }, isLeftToRight(), {
    left: 0
  }), isLeftToRight(false), {
    right: 0
  }),
  control: {
    display: 'block',
    width: '100%',
    height: '100%',
    opacity: 0,
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    cursor: function cursor(props) {
      return props.disabled ? 'not-allowed' : 'pointer';
    }
  },
  dot: _defineProperty(_defineProperty({
    display: 'inline-block',
    width: function width(_ref3) {
      var height = _ref3.height;
      return height;
    },
    height: function height(_ref4) {
      var _height2 = _ref4.height;
      return _height2;
    },
    borderRadius: '50%',
    background: function background(props) {
      return props.disabled ? 'var(--x-text-color-disabled)' : 'var(--texts-base)';
    },
    position: 'absolute',
    top: 0,
    bottom: 0,
    margin: ['auto', 0],
    pointerEvents: 'none'
  }, isLeftToRight(), {
    marginLeft: function marginLeft(_ref5) {
      var height = _ref5.height;
      return -height / 2;
    }
  }), isLeftToRight(false), {
    marginRight: function marginRight(_ref6) {
      var height = _ref6.height;
      return -height / 2;
    }
  })
};
var useStyles$1 = createUseStyles(useStyles, {
  name: 'range-slider'
});

var _excluded = ["className", "trackClassName", "hideProgress", "loadClassName", "dotClassName", "height", "step", "value", "defaultValue", "disabled", "min", "max", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function RangeSlider(_ref, ref) {
  var className = _ref.className,
    trackClassName = _ref.trackClassName,
    hideProgress = _ref.hideProgress,
    loadClassName = _ref.loadClassName,
    dotClassName = _ref.dotClassName,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 12 : _ref$height,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    value = _ref.value,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? 0 : _ref$defaultValue,
    disabled = _ref.disabled,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles$1({
    height: height,
    disabled: disabled
  });
  var isControlled = value !== undefined;
  var _useState = useState(function () {
      return Number(value) || defaultValue;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    val = _useState2[0],
    setNewVal = _useState2[1];
  var valChanged = function valChanged(e) {
    !isControlled && setNewVal(+e.target.value);
    onChange(e);
  };
  var curr = validateInputRange(Number(min), Number(max), Number(value !== null && value !== void 0 ? value : val));
  var offsetStyle = _defineProperty({}, document.documentElement.dir === 'ltr' ? 'left' : 'right', "".concat((curr - Number(min)) * 100 / (Number(max) - Number(min)), "%"));
  var widthStyle = {
    width: "".concat((curr - Number(min)) * 100 / (Number(max) - Number(min)), "%")
  };
  return /*#__PURE__*/jsxRuntimeExports.jsxs("label", {
    className: classNames(classes.root, className, _defineProperty({}, classes.disabled, disabled)),
    children: [/*#__PURE__*/jsxRuntimeExports.jsxs("span", {
      className: classes.content,
      children: [/*#__PURE__*/jsxRuntimeExports.jsx("i", {
        className: classNames(classes.stroke, classes.backLayer, trackClassName)
      }), !hideProgress && /*#__PURE__*/jsxRuntimeExports.jsx("i", {
        className: classNames(classes.stroke, classes.load, loadClassName),
        style: widthStyle
      }), /*#__PURE__*/jsxRuntimeExports.jsx("i", {
        className: classNames(classes.dot, dotClassName),
        style: offsetStyle
      })]
    }), /*#__PURE__*/jsxRuntimeExports.jsx("input", _objectSpread({
      className: classes.control,
      type: "range",
      draggable: false,
      value: value !== null && value !== void 0 ? value : val,
      onChange: valChanged,
      step: step,
      disabled: disabled,
      ref: ref,
      min: min,
      max: max
    }, props))]
  });
}
var RangeSlider$1 = /*#__PURE__*/forwardRef(RangeSlider);

export { RangeSlider$1 as default };
//# sourceMappingURL=index.js.map
